import { useEffect, useState } from 'react';
import appTheme from '../appTheme';

const getViewport = () => {
  if (window.innerWidth > appTheme.breakpoints.tablet - 1) {
    if (window.innerWidth < appTheme.breakpoints.desktop + 1) {
      return 'tablet';
    }
    return 'desktop';
  }
  return 'mobile';
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(process.browser ? getViewport() === 'mobile' : false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getViewport() === 'mobile');
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return isMobile;
};

export default useIsMobile;
